import _ from 'underscore';

import {Circle as CircleStyle , Style, Fill, Stroke, RegularShape, Text, Icon} from 'ol/style.js';
import Select from 'ol/interaction/Select';
import click from 'ol/events/condition';
import Draw from 'ol/interaction/Draw';
import Modify from 'ol/interaction/Modify';
import LineString from 'ol/geom/LineString';
import Polygon from 'ol/geom/Polygon';
import Snap from 'ol/interaction/Snap';
import MultiPoint from 'ol/geom/MultiPoint';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import doubleClick from 'ol/events/condition';

import Bar from 'ol-ext/control/Bar';
import EditBar from 'ol-ext/control/EditBar';
import Delete from 'ol-ext/interaction/Delete';
import Button from 'ol-ext/control/Button';
import Toggle from 'ol-ext/control/Toggle';
import TextButton from 'ol-ext/control/TextButton';
import Split from 'ol-ext/interaction/Split';
import UndoRedo from './undoredo';
import ModifyFeature from 'ol-ext/interaction/ModifyFeature';
import Splitter from 'ol-ext/interaction/Splitter';

import Menu from '../menu/model.js';
import PointMenu from '../menu/pointMenu.js';


import '../../../../styles/bar/bar.css';
import '../../../../styles/bar/edit.css';
import '../../../../styles/icomoon/style.css';

const uniqueArray = a => [...new Set(a.map(o => JSON.stringify(o)))].map(s => JSON.parse(s));

export default class DrawControl {

	 constructor() {
        this.name = 'DrawControl';
        this.mainbar = new Bar({
          className : 'ol-editbar',
          toggleOne : true
        });
        this.position = "top-left";
        this.map;
        this._source;
        this._nodeSource;
        this._layer;
        this._menu;
        this._nodeLayer;
        this._interactions = {};
        this.pointmap = new Map();
  	}

  	toString() {
        return this.name;
    }

    getMap() {
        return this.map;
    }


    addPointControl(){
        this._interactions.DrawPoint = new Draw({
              type: 'Point',
              source: this._source
        });

        var pedit = new Toggle({
              html: '<span  class="icon-side icon-beco-asset"></span><span class="ico-text">Asset</span>',
              title: 'Asset',
              interaction: this._interactions.DrawPoint
        });
        this.mainbar.addControl(pedit);
    }

    getCoordinateIdentifier(x,y){
        return x>=y ? ((x * x)+x+y) :(x+(y * y));
    }

    addModifyControl(){
        this._interactions.Modify = new Modify({
              source: this._source,
        });

        this._interactions.Modify.on('modifyend', function(e) {
            //TODO update time
            //https://gis.stackexchange.com/questions/175784/openlayers-3-how-to-get-only-the-modified-feature
        });

        var pmodify = new Toggle({
              html: '<span id="modify-button" class="icon-side icon-beco-edit"></span><span class="ico-text">Modify</span>',
              //className: 'ol-drawhole',
              title: 'Modify',
              interaction: this._interactions.Modify
        });
        this.mainbar.addControl(pmodify);
    }

    addPropertiesControl(){
      
        var _this = this;
        this._interactions.NodeSelect = new Select({
            condition: doubleClick,
            style : this.getSelectedNodeStyle(),
            layers : [this._nodeLayer]
        });
        var sel = this._interactions.NodeSelect;
        var selectCtrl = new Toggle({
            html: '<span id="node-config-button", class="icon-side icon-beco-nodeconfig"></span><span class="ico-text">Node Config</span>',
            title: "Node Config",
            interaction: sel
        });

        sel.on('change:active', function() {
            sel.getFeatures().clear();
        });

        sel.on('select', function(evt){
          if(evt.selected.length > 0){
              _this._menu.open(evt.selected[0], sel);          }
        });

        this.mainbar.addControl(selectCtrl);
    }

    addLinepropertiesControl(){
      
        var _this = this;
        this._interactions.LineSelect = new Select({
            condition: doubleClick,
            style : this.getSelectedStyle(),
            layers : [this._layer]
        });
        var sel = this._interactions.LineSelect;
        var selectCtrl = new Toggle({
            html: '<span id="node-line-button", class="icon-side icon-direction"></span><span class="ico-text">Route Config</span>',
            title: "Route Config",
            interaction: sel
        });

        sel.on('change:active', function() {
            sel.getFeatures().clear();
        });

        sel.on('select', function(evt){
          if(evt.selected.length > 0){
              _this._lineMenu.open(evt.selected[0], sel);          }
        });

        this.mainbar.addControl(selectCtrl);
    }

    addSelectControl(){
        // Sub bar
        var sbar = new Bar();
        var selectCtrl;
        this._interactions.Delete = new Delete();
        var del = this._interactions.Delete;
        del.setActive(false);
        if (this.getMap()) this.getMap().addInteraction(del);

        sbar.addControl (new Button({
            html: '<span  class="icon-side icon-delete"></span>',
            // className: 'ol-delete',
            title: "Delete",
            handleClick: function(e) {
              // Delete selection
              del.delete(selectCtrl.getInteraction().getFeatures());
              var evt = {
                type: 'select',
                selected: [],
                deselected: selectCtrl.getInteraction().getFeatures().getArray().slice(),
                mapBrowserEvent: e.mapBrowserEvent
              };
              selectCtrl.getInteraction().getFeatures().clear();
              selectCtrl.getInteraction().dispatchEvent(evt);
            }
        }));


        this._interactions.Select = new Select({
            condition: click,
            style : this.getSelectedStyle(),
            layers : [this._layer,this._polygonLayer]
        });
        var sel = this._interactions.Select;
        selectCtrl = new Toggle({
            className: 'have-submenu',
            html: '<span id="select-button" class="icon-side icon-beco-select"></span><span class="ico-text">Select</span>',
            title: "Select",
            interaction: sel,
            bar: sbar.getControls().length ? sbar : undefined,
            autoActivate:true,
            active:true
        });

        sel.on('change:active', function() {
            sel.getFeatures().clear();
        });

        this.mainbar.addControl(selectCtrl);
    }

    _setModifyInteraction(){
        this._interactions.ModifySelect = new ModifyFeature({
            features: this.getInteraction('Select').getFeatures()
        });
  
        if (this.getMap()) this.getMap().addInteraction(this._interactions.ModifySelect);
        // Activate with select
        this._interactions.ModifySelect.setActive(this._interactions.Select.getActive());
        this._interactions.Select.on('change:active', function() {
          this._interactions.ModifySelect.setActive(this._interactions.Select.getActive());
        }.bind(this));
    }

    addLineControl(){

        this._interactions.DrawLine = new Draw ({
            type: 'LineString',
            source: this._source,
            geometryName : 'LineString',
            // Count inserted points
            geometryFunction: function(coordinates, geometry) {
              if (geometry) geometry.setCoordinates(coordinates);
              else geometry = new LineString(coordinates);
              this.nbpts = geometry.getCoordinates().length;
              return geometry;
            }
        });

        var ledit = new Toggle({
          className: 'have-submenu',
          html: '<span id="draw-route-button" class="icon-side icon-beco-draw"></span><span class="ico-text">Draw Route</span>',
          title: 'Draw Route',
          interaction: this._interactions.DrawLine,
          // Options bar associated with the control
          bar: new Bar ({
            controls:[ 
              new TextButton({
                html: '<span class="icon-side icon-beco-undo"></span>',
                // className: 'ol-undo',
                title: "delete last point",
                handleClick: function() {
                  if (ledit.getInteraction().nbpts>1) ledit.getInteraction().removeLastPoint();
                }
              }),
              new TextButton ({
                // className: 'ol-finish',
                html: '<span class="icon-side icon-done"></span>',
                title: "finish",
                handleClick: function() {
                  // Prevent null objects on finishDrawing
                  if (ledit.getInteraction().nbpts>2) ledit.getInteraction().finishDrawing();
                }
              })
            ]
          }) 
        });

        this.mainbar.addControl(ledit);
    }

    _setDrawPolygon(className, interaction, title){
        var fedit = new Toggle ({
            className: 'have-submenu',
            html: '<span id="draw-poly-button" class="icon-side icon-beco-area-select"></span><span class="ico-text">Polygon</span>',
            title: title,
            interaction: interaction,
            // Options bar associated with the control
            bar: new Bar({
              controls:[ 
                new TextButton ({
                  html: '<span class="icon-side icon-beco-undo"></span>',
                  title: 'undo last point',
                  handleClick: function(){
                    if (fedit.getInteraction().nbpts>1) fedit.getInteraction().removeLastPoint();
                  }
                }),
                new TextButton({
                  html: '<span class="icon-side icon-done"></span>',
                  title: 'finish',
                  handleClick: function() {
                    // Prevent null objects on finishDrawing
                    if (fedit.getInteraction().nbpts>3) fedit.getInteraction().finishDrawing();
                  }
                })
              ]
            }) 
        });
      this.mainbar.addControl(fedit);
    }

    addPolygonControl(){
        this._interactions.DrawPolygon = new Draw ({
            type: 'Polygon',
            source: this._polygonSource,
            // Count inserted points
            geometryFunction: function(coordinates, geometry) {
              this.nbpts = coordinates[0].length;
              if (geometry) geometry.setCoordinates([coordinates[0].concat([coordinates[0][0]])]);
              else geometry = new Polygon(coordinates);
              return geometry;
            }
        });
        this._setDrawPolygon(
            'ol-drawpolygon', 
            this._interactions.DrawPolygon, 
            'Polygon'
        );
    }


    addSplitControl(){
        this._interactions.Split = new Split ({
              sources: this._source
        });
        var split = new Toggle ({
          // className: 'ol-split',
          html: '<span id="split-button" class="icon-side icon-beco-line-edit"></span><span class="ico-text">Route Points</span>',
          title: 'Route Points',
          interaction: this._interactions.Split
        });
        this.mainbar.addControl(split);
    }

    getInteraction(name){
        return this._interactions[name];
    }

   	addUndoRedoControl(){
        var _this = this;
    	  this._interactions.UndoRedo = new UndoRedo ();
        if (this.getMap()) this.getMap().addInteraction(this._interactions.UndoRedo);
         // Prevent selection of a deleted feature
        this._interactions.UndoRedo.on('undo', function(e) {
          // console.log(e);
           if (e.action.type === 'addfeature') {
              _this.getInteraction('Select').getFeatures().clear();
              //_this.getInteraction('Transform').select();
           }
        });

        // Add buttons to the bar
        var bar = new Bar({ 
          group: true,
          controls: [
            new Button({
              html: '<span class="icon-side icon-beco-undo"></span><span class="ico-text">Undo</span>',
              title: 'undo...',
              handleClick: function() {
                _this._interactions.UndoRedo.undo();
              }
            }),
            new Button({
              html: '<span class="icon-side icon-beco-redo"></span><span class="ico-text">Redo</span>',
              title: 'redo...',
              handleClick: function() {
                _this._interactions.UndoRedo.redo();
              }
            })
          ]
        });
        this.mainbar.addControl(bar);
    }
    
    getNodeStyle(feature){

        var fillColor = "#26ace3";
        if(feature.getProperties()){
            if(feature.getProperties().location && feature.getProperties().beacon){
              fillColor = "#4A8C7A";
            } else {
                if(feature.getProperties().location){
                  fillColor = "#546EB3";
                }else if(feature.getProperties().beacon){
                  fillColor = "#8F7E8C";
                }
            }
        }
        
        var pointName = "";
        if(feature.get(PointMenu.getPointVariable) && feature.get(PointMenu.getPointVariable).visible){
            pointName = feature.get(PointMenu.getPointVariable).name ;
        }
        return new Style({
            image: new CircleStyle({
                radius: 6,
                fill: new Fill({ color: fillColor }),
                stroke: new Stroke({
                    color: '#adccd9',
                    width: 1.5
                })
            }),
            text: new Text({
                offsetY: 13,
                text: pointName,
                font: 'bold 10px Open Sans,sans-serif',
                fill: new Fill({ color: '#666666' }),
                stroke: new Stroke({ color: '#666666', width: 0.5 })
            })
        });
    }

    getLabelstyle() {
      return new Style({
            text: new Text({
              font: 'normal 12px "Open Sans", "Arial", "sans-serif"',
              placement: 'line',
              fill: new Fill({
                color: '#FFFFFF'
              }),
              stroke: new Stroke({color: "#5D5755", width: 3}),
              overflow: true,
            })
         });
      }

    getSelectedNodeStyle(){
        return new Style({
            image: new CircleStyle({
                radius: 8,
                fill: new Fill({ color: '#de837a' }),
                stroke: new Stroke({
                    color: '#de837a',
                    width: 1
                })
            })
        });
    }

    getStyle(feature){
        var geometry = feature.getGeometry();
        var styles = [
            new Style({
              stroke: new Stroke({ color: '#adccd9',width: 6 }),
              fill: new Fill({ color: '#adccd9' }),
            })
        ];

        if(feature.getProperties().label){
          if(geometry.getType() == 'LineString'){
            styles.push(new Style({
              geometry: geometry,
              text: new Text({
                font: 'normal '+feature.getProperties().labelTextSize+'px "Open Sans", "Arial", "sans-serif"',
                placement: 'line',
                text:feature.getProperties().label,
                fill: new Fill({
                  color: feature.getProperties().labelTextColor
                }),
                stroke: new Stroke({color: feature.getProperties().labelBorderColor, width: 3}),
                overflow: true,
              })
            }));
          }
          
        }
        if(feature.getProperties().direction){
            geometry.forEachSegment(function(start, end) {

            var dx, dy;
            if(feature.getProperties().direction == 1){
              dx = end[0] - start[0];
              dy = end[1] - start[1];
            }else {
              dx = start[0] - end[0];
              dy = start[1] - end[1];
            }
            
            var rotation = Math.atan2(dy, dx);

            var midPoint = [((start[0] + end[0]) / 2), ((start[1] + end[1]) / 2)];
            // arrows
            styles.push(new Style({
              geometry: new Point(midPoint),
              image: new Icon({
                src: 'public/images/arrow.png',
                anchor: [0.75, 0.5],
                rotateWithView: true,
                rotation: -rotation
              })
            }));
          });
        }

        return styles;
    }

    getAreaStyle(feature){
        return [
            new Style({
              stroke: new Stroke({ color: '#adccd9',width: 6 }),
              fill: new Fill({ color: '#df4a43' }),
            }),
        ];
    }

    getSelectedStyle(){
        return [
            new Style({
              stroke: new Stroke({ color: '#de837a',width: 6 }),
              fill: new Fill({ color: '#de837a' }),
            }),
        ];
    }

    /**
    * Add different draw controls to the Map.
    * First 2 only for reference : TODO remove on final build
    * @param {import {Vector as VectorLayer} from 'ol/layer.js';} Vector
    *   Vector data that is rendered client-side.
    * @param {import Map from 'ol/Map.js';} map
    *   Core Map layer.
    * @param {options} map
    *   Settings for the draw controls.
    */
    addControls(options){
        options = options || {};
        this.map = options.map;
        this._layer = options.layer;
        this._nodeLayer = options.nodeLayer;
        this._source = options.layer.getSource();
        this._polygonSource = options.polygonLayer.getSource();
        this._polygonLayer = options.polygonLayer;
        this._nodeSource = options.nodeLayer.getSource();
        this._menu = options.menu;
        this._lineMenu = options.lineMenu;

        this.mainbar.setPosition(this.position);
        
        if (options.select == true) {   
          this.addSelectControl();
          this._setModifyInteraction();
        }
        if (options.modify == true) {   
          this.addModifyControl();
        }
        if (options.point == true) {   
          //this.addPointControl();
        }
        this.addPropertiesControl();
        this.addLinepropertiesControl();
        if (options.line == true) {   
          this.addLineControl();
        }
        if (options.polygon == true) {   
          this.addPolygonControl();
        }
        if (options.split == true) {   
          this.addSplitControl();
        }
        if (options.undo == true) {   
          this.addUndoRedoControl();
        }


        var _this = this;
        this._source.on('change', function(event) {
              //console.log("change: ", event.target.getFeatures());
              const points = [];

              _(_this._nodeSource.getFeatures()).each(function (feature) {
                    if(feature.getProperties()){
                      if(feature.getProperties().location || feature.getProperties().beacon){
                          var pt = feature.getGeometry().getCoordinates();
                          var id = _this.getCoordinateIdentifier(pt[0], pt[1]);
                          _this.pointmap.set(id,feature.getProperties());
                      }
                    }
            
              });

              _this._nodeSource.clear();
              _(event.target.getFeatures()).each(function (feature) {
                  if(feature.getGeometry().getType() == 'LineString'){
                      points.push(...feature.getGeometry().getCoordinates());
                  }
              });

              

              _(uniqueArray(points)).each(function (point) {
                  var feature = new Feature(
                      new Point(point)
                  );
                  var id = _this.getCoordinateIdentifier(point[0], point[1]);
                  if(_this.pointmap.get(id)){
                    feature.setProperties(_this.pointmap.get(id));
                  }
                  _this._nodeSource.addFeature(feature);
              });


        });
      	
        //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set
        // Add splitter before other interaction
        var splitter = new Splitter({ source: this._source });
        this.map.addInteraction(splitter);


        this.map.addControl(this.mainbar);

        this.map.addInteraction(new Snap({ 
          source: options.layer.getSource() 
        }));

        this.map.on('pointermove', function(event) {
            var hasFeature = _this.map.forEachFeatureAtPixel(_this.map.getEventPixel(event.originalEvent), function(feature) {
              return true ;
            });

            this.getTargetElement().style.cursor = hasFeature ? 'pointer' : '';
        });

    }


}